'use client'
import * as React from 'react'
import type { SiteDataQuery } from 'codegen/generated/cf'
import { tw } from 'utils/classnames'

import { BannerContainer } from './container'

type BannerProps = Omit<
  NonNullable<SiteDataQuery['siteData']['onHoldSubscriptionBanner']>,
  '__typename' | 'type'
> & {
  type: string
}

interface Props {
  banner: BannerProps
}

export function SubscriptionOnHold({ banner }: Props) {
  const { text, backgroundColor } = banner

  return (
    <>
      <BannerContainer
        className={tw('sticky left-0 top-0 z-[1200] min-h-[49px] px-0.5')}
        backgroundColor={backgroundColor}
        wrapperClassName="text-16 max-w-[1220px] px-[20px] xl:m-auto xl:w-full"
        bannerType={banner.type}
      >
        <div className="flex w-full flex-col items-center justify-between md:flex-row">
          <div
            className="[&_a]:text-cf-white text-aubergine-500 mb-[10px] text-center text-[16px] font-bold leading-[1.2] md:mb-0 md:mt-[5px] md:p-0 [&_a]:underline"
            dangerouslySetInnerHTML={{ __html: text }}
          />
        </div>
      </BannerContainer>
    </>
  )
}
